import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import Collapse from '@mui/material/Collapse';

import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';


import UnpublishedIcon from '@mui/icons-material/Unpublished';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';


import Select from '@mui/material/Select';

import FormControl from '@mui/material/FormControl';

import FormControlLabel from '@mui/material/FormControlLabel';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

import CheckBoxIcon from '@mui/icons-material/CheckBox';
import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault';
import ClearIcon from '@mui/icons-material/Clear';
let strUser=[{title:'',year:0}];
const strUserdeflt=[];


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});


export default class  Approveleave extends Component {


 constructor(props) {
    super(props);

    var today = new Date();
	var todayMonth=(today.getMonth() + 1);
	if(todayMonth<10)
		todayMonth='0'+todayMonth;
    var        cudate = today.getFullYear() + '-' + todayMonth + '-' + today.getDate();
	
	 
	 
    this.state = { lm_leavetypes:'',redirect:false,leavedata:[],lvid:'',page: 0 ,prevpage:0,totaldata:0,rowsPerPage:20,rowsPaging:[],
	  order:'desc' ,orderby:'',title:'',type:'',unit:'',search:'',comments:'',searcharray:[],auotuserarray:[],fdate1:'',tdate1:cudate,fdate:Date.now(),tdate:Date.now(),
	  user:'',lvstatus:'',
	
	
	};
   this.updateDonenewParent = this.updateDonenewParent;
}

updateDonenewParent = (text) => {	this.apicall(this.state.page,this.state.rowsPerPage);  }



myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  
  this.setState({[nam]: val});

}

handleboxChange = (idx,firstrow) => evt  => {    
  let nam = evt.target.name;
  
              
			 
			  const arradata=[...this.state.leavedata];
			  arradata[firstrow].lm_comments=evt.target.value;
			  
		this.setState({leavedata:arradata});
		
}


componentDidMount() {
	
	if(localStorage.getItem("AYLuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Default'
          })
		  }
		 
		  	
	
		  document.title = "AthaYog Living - Approve Leave";
	
	this.apicall(this.state.page,this.state.rowsPerPage);
	
}


apicall(page,rowsPerPage){
	  axios.get(Serverurl+'ajaxleaves.php?action=list&lm_type='+this.state.type+'&fromdate='+this.state.fdate1+'&todate='+this.state.tdate1+'&lm_createduserid='+this.state.user+'&lm_status='+this.state.lvstatus+'&Sorting='+this.state.orderby+' '+this.state.order+'&StartIndex='+page+'&PageSize='+rowsPerPage)

  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  leavedata: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   rowsPaging:[],
			  
		    });	
			
		
     }
	 
	 else{
		   this.setState({leavedata:[],totaldata:0});
	 }
  
    });
}
 
leaveApprove(lvid,lvstatus,comments){ 
 

let r = window.confirm("Do you really want to Approve?");
 if(r === true){ //sign Out logic
 var formData = new FormData();
     formData.append('action','leaveapprove')
	 formData.append('lm_id',lvid)
	 formData.append('lm_status',lvstatus)
	 formData.append('lm_comments',comments)
	 formData.append('userid',localStorage.getItem("AYLuserid"))
	  
	 axios.post(Serverurl+"ajaxleaves.php", formData, {
        }).then(res => {
    
            this.apicall(this.state.page,this.state.rowsPerPage);
  
    
            });
 }
      }
     

leaveReject(lvid,lvstatus,comments){ 
 
 

 

	
let r = window.confirm("Do you really want to Reject?");
 if(r === true){ //sign Out logic
 var formData = new FormData();
     formData.append('action','leaveapprove')
	 formData.append('lm_id',lvid)
	 formData.append('lm_status',lvstatus)
	 formData.append('lm_comments',comments)
	 formData.append('userid',localStorage.getItem("AYLuserid"))
	
	
	 axios.post(Serverurl+"ajaxleaves.php", formData, {
        }).then(res => {
    
            this.apicall(this.state.page,this.state.rowsPerPage);
  
    
            });
 }
      }
     
	 	 
	 
	 
LeaveAWP(lvid,lvstatus,comments){ 
 
 var formData = new FormData();
     formData.append('action','leaveapprove')
	 formData.append('lm_id',lvid)
	 formData.append('lm_status',lvstatus)
	
	 formData.append('userid',localStorage.getItem("AYLuserid"))
	formData.append('lm_comments',comments)
	
	
	 axios.post(Serverurl+"ajaxleaves.php", formData, {
        }).then(res => { 
            
          this.apicall(this.state.page,this.state.rowsPerPage);
  
    
            });

      }
  
  
handleChangePage = (event, newPage) => {  

    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  };   
  
  
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  

   
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
	
	
  };
  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};
  
  

  
 handfrChange = (date) => {
	 var month="";
	
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}
     this.setState({ fdate:date,
fdate1:date.getFullYear() + '-' + month + '-' +date.getDate()
	 })
	
	
  }  
    



  

handleSubmit= (event) => {
    
    event.preventDefault();

	
	this.apicall(this.state.page,this.state.rowsPerPage);
	
	
} 

   handnodateChanges = (date) => {
	
	  var month="";
	  var date = new Date(date);
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}   
	 
     this.setState({ fdate:dayjs(date),
fdate1:date.getFullYear() + '-' + month + '-' +date.getDate()
	 })
	
	
  }
  handtoChanges = (date) => {
	
	  var month="";
	  var date = new Date(date);
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}   
	 
     this.setState({ todate:dayjs(date),
tdate1:date.getFullYear() + '-' + month + '-' +date.getDate()
	 })
	
	
  }
  
render() {

if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    } 
return (



<React.Fragment>
<div className="boxheading">
				
<h2>Approve Leave</h2>
</div>
<div className="clear"></div>


<div className="searchmaster">
  <ul>
  <li>
<p>From Date</p>
 <p>
 <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.fdate) }
className="txtbox" 
 inputProps={{tabIndex: "1"}}
    onChange={this.handnodateChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
		
		</p></li>
<li>
	<p>To Date</p>
	  <p>
	   <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker 
value= {dayjs(this.state.tdate) }
className="txtbox" 
 inputProps={{tabIndex: "2"}}
    onChange={this.handtoChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
		
	
		</p></li>		
	
 
<li>	
		 <p>Leave Type</p> 
		  <p> <FormControl  className="stadrp">
       
        <Select
		variant="outlined"
        native
         value={this.state.type}
		 inputProps={{ tabIndex: "3" }}
          onChange={this.myChangeHandler} className="txtbox"
        name='type'
         id='type'
		 fullWidth
		 
        >
		   
          <option value={''}>Select Type</option>
          <option value={1}>Permission</option>
          <option value={2}>Leave</option>
		  
          </Select>
      </FormControl>
		  	   </p>
			   </li>
			   
			
			{this.state.type === "2"  && ( 
			
			<li>	
		 <p>Leave Type</p> 
		  <p> <FormControl  className="stadrp">
       
        <Select
		variant="outlined"
        native
         value={this.state.lm_leavetypes}
		 inputProps={{ tabIndex: "3" }}
          onChange={this.myChangeHandler} className="txtbox"
        name='lm_leavetypes'
         id='lm_leavetypes'
		 fullWidth
		 
        >
		   
          <option value={''}>Select Leave Type</option>
          <option value={1}>Medical Leave</option>
          <option value={2}>Casual Leave</option>
		  
          </Select>
      </FormControl>
		  	   </p>
			   </li>
			
			)}

<li>
<p>Leave Status</p> 
 <p> <FormControl  className="stadrp">
       
        <Select
		variant="outlined"
        native
         value={this.state.lvstatus}
          onChange={this.myChangeHandler} className="txtbox"
        name='lvstatus'
         id='lvstatus'
		 fullWidth  inputProps={{ tabIndex: "4" }}
		 
        >
		   
          <option value={''}>Select Status</option>
		  <option value={0}>Waiting For Approval</option>
          <option value={1}>Approved</option>
          <option value={2}>Rejected</option>	  
		  <option value={4}>Absent without permission</option>
          </Select>
      </FormControl>
		  	   </p>
</li>

	   
		<li>
<p >
		<Button variant="contained" onClick={this.handleSubmit} className="frmSecondarybtn" endIcon={<SearchIcon />}>
        Search
      </Button></p>
		

</li>		
			   
			   
			   
  </ul>
  </div>



<div className="backbutton">
<div className="note">
<p> <span style={{"color":"red"}}>*Note : </span><CheckBoxIcon className="iconvertical"/>   - Approved, &nbsp;&nbsp;<DisabledByDefaultIcon className="iconvertical"/> - Rejected, &nbsp;&nbsp;<ClearIcon className="iconvertical"/>  - Canceled by user,&nbsp;&nbsp;<UnpublishedIcon className="iconvertical"/> - Absent without permission </p>

</div>
</div>
<div className="clear"></div>


  <Paper className={useStyles.root}>
  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  

					  
					  
                      <TableBody>

                     {this.state.leavedata.map((item,index) => { 
 if(this.state.totaldata>0)
 {
				 
           return ( <React.Fragment>
 <TableRow key={index} >

<TableCell className={useStyles.row}>


  

  
  <div className="usrdetails">
       <div className="uslvleft">
	 {item.lm_type === "2" && ( <React.Fragment>  
  <p><b>{item.st_name} </b> Applied <b>{item.leavetype}</b> on    {item.applieddate}  from   <b>{item.lm_fromdate } </b>  to <b> {item.lm_todate } </b> ({item.days + " " + " Days"})</p>
  </React.Fragment>)}
  
  
  {item.lm_type === "1" && ( <React.Fragment>  
  <p><b>{item.st_name} </b> Applied <b>{item.leavetype}</b> on    {item.applieddate} for <b>{item.perdate}</b> from   <b>{item.ftime} </b>  to <b> {item.ttime } </b> ({item.hours +" " + " Hours" })</p>
  </React.Fragment>)}
  
 


  <p> Reason : {item.lm_details} </p>
  
  
   </div>
   
    <div className="uslvright">
	
	
	{item.lm_status === "0" && ( <React.Fragment>
  <p className="lvcmt">	<TextField
            id="outlined-multiline-static"
         
          multiline
          rows={4}
		  variant="outlined"           
		    value={this.state.leavedata[index].lm_comments}
            id={this.state.leavedata[index].idx} 
			
            placeholder="Comments"
            name="lm_comments" 
			onChange={this.handleboxChange(item.idx,index)}
           
          />  
		  
	&nbsp;&nbsp;	
  
   <React.Fragment>  <Button variant="contained" className="frmSecondarybtn" onClick={()=>{this.leaveApprove(item.lm_id,1,item.lm_comments)}}>Approve
</Button>
	&nbsp;&nbsp;<Button variant="contained" className="frmthirdbtn" onClick={()=>{this.leaveReject(item.lm_id,2,item.lm_comments)}}> Reject
</Button>  &nbsp;&nbsp;<Button variant="contained" className="frmSecondarybtn" onClick={()=>{this.LeaveAWP(item.lm_id,4,item.lm_comments)}}> AWP
</Button> </React.Fragment>
	  
		  
		  
		  </p>		
  
 
	</React.Fragment>)}
	
	
    { item.lm_status=== "1" &&(
	    <React.Fragment>
	    <CheckBoxIcon className="svgiconleave"/> </React.Fragment>
	   )}
	   &nbsp;{ item.lm_status=== "2" &&(
	    <React.Fragment>
	    <DisabledByDefaultIcon className="svgiconleaves"/> </React.Fragment>
	   )}
	   &nbsp;{ item.lm_status=== "3" &&(
	    <React.Fragment>
	    <ClearIcon className="svgiconleave"/> </React.Fragment>
	   )}
	    &nbsp;{ item.lm_status=== "4" &&(
	    <React.Fragment>
	    <UnpublishedIcon className="svgicnleave"/> </React.Fragment>
	   )}
	   
	   
   </div>
  <div className="clear"></div> 

  </div>
  
  {item.lm_comments !=='' &&(  <React.Fragment>
  <p> Comment : <b>{item.lm_comments} </b> by <b>{item.name} </b></p>
   </React.Fragment>
  )}
  
  

   
    
 <div className="clear"></div> 
  
  
  
  
  
  


</TableCell>
 </TableRow>


				</React.Fragment>	
				);
				}
						 else{
					 return ( <React.Fragment>
				<TableRow  >
<TableCell rowspan="6">
<h3>No Records</h3>
</TableCell>
				</TableRow>
				</React.Fragment>	
				);	
				}
					})}
                      </TableBody>


</Table>
  </TableContainer> 
 <TablePagination  
 rowsPerPageOptions={[10,50,100,150,200]}
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}  
      />    
  </Paper> 



</React.Fragment>






     );
    }
   }
